import { render } from "./ChildrenPrivacy.vue?vue&type=template&id=733dd134&scoped=true"
const script = {}

import "./ChildrenPrivacy.vue?vue&type=style&index=0&id=733dd134&scoped=true&lang=css"

import exportComponent from "F:\\unilearn\\unilearn-web-vue3\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-733dd134"]])

export default __exports__